import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import CajaChica from './pages/CajaChica';
import ReporteBI from './pages/ReporteBI';
import { offlineStore } from './services/offlineStore';

// Componente para depurar transiciones de rutas
const RouteDebugger = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('🔄 [App] Transición de ruta:', {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      timestamp: new Date().toISOString()
    });
  }, [location]);

  return null;
};

function App() {
  console.log('🚀 [App] Componente App montado');

  // Inicializar sincronización automática al montar la app
  useEffect(() => {
    // Cargar gastos pendientes al iniciar
    offlineStore.loadPendingExpenses();
    
    // Iniciar sincronización automática cada 5 segundos
    offlineStore.startAutoSync(5000);
    
    // Sincronizar inmediatamente si hay conexión
    if (offlineStore.hasConnection) {
      offlineStore.syncExpenses();
    }
    
    // Limpiar al desmontar
    return () => {
      offlineStore.stopAutoSync();
    };
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <RouteDebugger />
          <Routes>
            {/* Rutas protegidas */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/caja-chica" replace />} />
              <Route path="caja-chica" element={<CajaChica />} />
              <Route path="reporte-bi" element={<ReporteBI />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
